import { render, staticRenderFns } from "./InQuestionC.vue?vue&type=template&id=45235242&"
import script from "./InQuestionC.vue?vue&type=script&lang=js&"
export * from "./InQuestionC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports